import React, { useState } from 'react'

import { Button } from 'src/components/__legacy__/button/button'
import { Trial } from 'src/features/trial/types'
import { Member } from 'src/legacy_modules/entities/member/entity'
import { fetchDetail } from 'src/legacy_modules/entities/member/request'
import { useMirohaToast } from 'src/lib/chakra-theme/components/toast/use-miroha-toast'

import { EditModal } from './edit-modal/edit-modal'

type Props = {
  memberUid: string
  selectedTrial: Trial
}

export const MemberEditButton: React.FC<Props> = props => {
  const { memberUid, selectedTrial } = props
  const [modalOpen, setModalOpen] = useState(false)
  const [member, setMember] = useState<Member>()

  const toast = useMirohaToast()

  const onClick = () => {
    const fetchMemberDetail = async () => {
      try {
        const res = await fetchDetail({
          trialUid: selectedTrial.uid,
          memberUid,
        })
        if (res) {
          setMember(res)
        }
        setModalOpen(true)
      } catch (error) {
        toast({ status: 'error', title: error.message })
        setModalOpen(false)
      }
    }
    fetchMemberDetail()
  }

  return (
    <>
      <Button
        text="編集"
        size="S"
        buttonType="normal"
        iconName="edit"
        onClick={onClick}
      />
      {modalOpen && !!member && (
        <EditModal
          member={member}
          onClose={() => setModalOpen(false)}
          onSubmit={values => console.warn(values)}
          selectedTrial={selectedTrial}
        />
      )}
    </>
  )
}
